<!--
Author: TangChen
Date: 2019-10-23
Desc: 基本信息
 -->
<template>
    <div :class="'view-basic-info view bg-white' + className">
        <comp-title :title="title" />
        <nav-bar v-if="navs.length>1" :navs="navs" />
        <div class="basic-form">
            <el-form
                ref="basicInfo"
                :model="basicInfo"
                :rules="rules"
                label-width="370px"
                class="basicInfo"
                v-on:submit.native.prevent
            >
                <el-form-item v-if="invtp==='2'" label="产品名称：" prop="productname">
                    <el-input v-model.trim="basicInfo.productname" placeholder="请输入产品名称" :maxlength="30" />
                </el-form-item>
                <el-form-item v-if="invtp==='2'" label="产品简称：" prop="product">
                    <el-input v-model.trim="basicInfo.product" placeholder="请输入产品简称" :maxlength="30" />
                </el-form-item>
                <el-form-item v-if="invtp==='2'" label="产品备案编号：" prop="filingno">
                    <el-input v-model.trim="basicInfo.filingno" placeholder="请输入产品备案编号" :maxlength="20" />
                </el-form-item>
                <el-form-item v-if="invtp==='2'" label="产品类型：" prop="producttype">
                    <el-select
                        v-model="basicInfo.producttype"
                        placeholder="请选择投产品类型"
                    >
                        <el-option
                            v-for="item in producttype"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="beginSet.max" label="成立日期：" prop="begindate">
                    <date-picker :date="beginSet" v-on:date-get="beginDate" />
                </el-form-item>
                <el-form-item v-if="beginSet.max&&invtp==='2'" label="产品到期日期：" prop="begindate">
                    <date-picker :date="endSet" v-on:date-get="endDate" />
                </el-form-item>
                <el-form-item v-if="invtp==='2'" label="产品备案机构：" prop="filinginstitution">
                    <el-input v-model.trim="basicInfo.filinginstitution" placeholder="请输入产品备案机构" :maxlength="30" />
                </el-form-item>
                <el-form-item v-if="invtp==='2'" label="产品管理人：" prop="mname">
                    <el-input v-model="basicInfo.mname" placeholder="请输入产品管理人" :maxlength="32" />
                </el-form-item>
                <el-form-item v-if="invtp==='2'" label="管理人类型：" prop="mainvtp">
                    <el-select
                        v-model.trim="basicInfo.mainvtp"
                        placeholder="请选择管理人类型"
                    >
                        <el-option
                            v-for="item in mainvtp||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="invtp==='2'" label="管理人证件类型：" prop="macertificatetype">
                    <el-select
                        v-model.trim="basicInfo.macertificatetype"
                        placeholder="请选择管理人类型"
                    >
                        <el-option
                            v-for="item in macertificatetype||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="invtp==='2'" label="管理人证件号码：" prop="macertificateno">
                    <el-input v-model="basicInfo.macertificateno" placeholder="请输入产品管理人证件号码" :maxlength="40" />
                </el-form-item>
                <el-form-item v-if="invtp==='2'" label="管理人证件有效期：" prop="mavailddate">
                    <date-picker :date="manaDateSet" v-on:date-get="mavailddate" />
                </el-form-item>
                <el-form-item v-if="isTaTwo&&invtp==='2'" label="行业：" prop="industrycode">
                    <el-select
                        v-model="basicInfo.industrycode1"
                        placeholder="请选择管理人所在行业"
                        style="width:150px!important"
                        :disabled="industrycode1.length<=0"
                    >
                        <el-option
                            v-for="item in industrycode1"
                            :key="item.subitem"
                            :label="item.subitemname+' '+item.subitem"
                            :value="item.subitem"
                        />
                    </el-select>
                    <el-select
                        v-model="basicInfo.industrycode2"
                        placeholder="请选择行业"
                        style="width:150px!important"
                        :disabled="industrycode2.length<=0"
                    >
                        <el-option
                            v-for="item in industrycode2"
                            :key="item.subitem"
                            :label="item.subitemname+' '+item.subitem"
                            :value="item.subitem"
                        />
                    </el-select>
                    <el-select
                        v-model="basicInfo.industrycode3"
                        placeholder="请选择行业"
                        :disabled="industrycode3.length<=0"
                    >
                        <el-option
                            v-for="item in industrycode3"
                            :key="item.subitem"
                            :label="item.subitemname+' '+item.subitem"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>

                <div v-if="invtp==='2'" class="line-pad">
                    <div class="bt-white"></div>
                </div>
                <el-form-item v-if="invtp==='0'" label="投资者分类：" prop="custtype">
                    <el-select
                        v-model="basicInfo.custtype"
                        placeholder="请选择投资者分类"
                        :disabled="invtp==='2'"
                    >
                        <el-option
                            v-for="item in custType"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="invtp==='0'" :label="(invtp==='0'?'':'持有')+'机构类型：'" prop="institutiontype">
                    <el-select
                        v-model="basicInfo.institutiontype"
                        placeholder="请选择机构类型"
                    >
                        <el-option
                            v-for="item in orgCates"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="invtp==='0'" :label="(invtp==='0'?'':'持有')+'机构名称：'" prop="custname">
                    <el-input v-model.trim="basicInfo.custname" placeholder="请输入机构名称" />
                </el-form-item>
                <el-form-item v-if="invtp==='0'" label="金融机构类型：" prop="finorgtype">
                    <el-select
                        v-model="basicInfo.finorgtype"
                        filterable
                        :disabled="basicInfo.custtype!=='02'"
                        placeholder="请选择金融机构类型"
                    >
                        <el-option
                            v-for="item in $cache.getDict('120113')||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="证件类型：" prop="cardCate">
                    <el-radio-group v-model="basicInfo.cardCate" class="checkbox-sel">
                        <el-radio v-for="item in cardCate" :key="item.id" :label="item.id">
                            <el-tooltip
                                v-if="item.text"
                                class="item"
                                effect="info"
                                :content="item.text"
                                placement="top"
                            >
                                <div class="sel-icon">
                                    {{ item.name }}
                                </div>
                            </el-tooltip>
                            <div v-else class="sel-icon">
                                {{ item.name }}
                            </div>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="basicInfo.cardCate==='3'" label="其它证件类型：" prop="certificatetype">
                    <el-select
                        v-model="basicInfo.certificatetype"
                        filterable
                        placeholder="请选择其它证件类型"
                    >
                        <el-option
                            v-for="item in cardNum||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="basicInfo.cardCate==='3'" label="其它证件号码：" prop="certificateno">
                    <el-input v-model.trim="basicInfo.certificateno" placeholder="请输入证件号码" :maxlength="18" />
                </el-form-item>
                <el-form-item v-if="basicInfo.cardCate==='2'" label="税务登记证：" prop="certificateno1">
                    <el-input v-model.trim="basicInfo.certificateno1" placeholder="请输入证件号码" :maxlength="18" />
                </el-form-item>
                <el-form-item v-if="basicInfo.cardCate==='2'" label="组织机构代码证：" prop="certificateno2">
                    <el-input v-model.trim="basicInfo.certificateno2" placeholder="请输入证件号码" :maxlength="18" />
                </el-form-item>
                <el-form-item v-if="basicInfo.cardCate!=='3'" label="营业执照号码：" prop="certificateno3">
                    <el-input v-model.trim="basicInfo.certificateno3" placeholder="请输入证件号码" :maxlength="18" />
                </el-form-item>
                <el-form-item v-if="dateSet.max" label="证件有效期：" prop="vailddate">
                    <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                </el-form-item>
                <el-form-item v-if="isTaTwo" label="注册资本（元）：" prop="registeredcapital">
                    <el-input v-model.trim="basicInfo.registeredcapital" placeholder="请输入注册资本" :maxlength="18" />
                </el-form-item>
                <el-form-item v-if="isTaTwo" label="注册资产币种：" prop="registercurrencytype">
                    <el-select
                        v-model="basicInfo.registercurrencytype"
                        placeholder="请选择注册资产币种"
                    >
                        <el-option
                            v-for="item in registercurrencytype"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="isTaTwo" label="经营范围：" prop="scopeofbusiness">
                    <el-input v-model.trim="basicInfo.scopeofbusiness" placeholder="请输入经营范围" :maxlength="64" />
                </el-form-item>
                <el-form-item v-if="isTaTwo&&invtp!=='2'" label="行业：" prop="industrycode">
                    <el-select
                        v-model="basicInfo.industrycode1"
                        placeholder="请选择行业"
                        style="width:150px!important"
                        :disabled="industrycode1.length<=0"
                    >
                        <el-option
                            v-for="item in industrycode1"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                    <el-select
                        v-model="basicInfo.industrycode2"
                        placeholder="请选择行业"
                        style="width:150px!important"
                        :disabled="industrycode2.length<=0"
                    >
                        <el-option
                            v-for="item in industrycode2"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                    <el-select
                        v-model="basicInfo.industrycode3"
                        placeholder="请选择行业"
                        :disabled="industrycode3.length<=0"
                    >
                        <el-option
                            v-for="item in industrycode3"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>

                <p class="pTip">
                    注册地址
                </p>
                <country-city-select ref="livingaddress" v-model="usefullifeObj" required v-on:input="getUsefullife"></country-city-select>
                <el-form-item label="注册地址详细地址：" prop="usefullife">
                    <el-input v-model.trim="basicInfo.usefullife" placeholder="请输入注册地址" :maxlength="30" />
                </el-form-item>

                <p class="pTip">
                    通讯地址
                </p>
                <country-city-select ref="livingaddress" v-model="livingAddressObj" required v-on:input="getAddress"></country-city-select>
                <el-form-item label="通讯地址详细地址：" prop="address">
                    <el-input v-model.trim="basicInfo.address" placeholder="请输入详细地址" :maxlength="64" />
                </el-form-item>

                <el-form-item label="传真(非必填)：" prop="fax">
                    <el-select
                        v-model="basicInfo.faxcycode"
                        placeholder="请选择国家码"
                        style="width:150px!important"
                    >
                        <el-option
                            v-for="item in faxcycode"
                            :key="item.subitem"
                            :label="item.subitemname+' '+item.subitem"
                            :value="item.subitem"
                        />
                    </el-select>
                    <el-select
                        v-if="basicInfo.faxcycode == '86'"
                        v-model="basicInfo.faxareacode"
                        placeholder="请选择地区码"
                        style="width:150px!important"
                    >
                        <el-option
                            v-for="item in faxareacode"
                            :key="item.subitem"
                            :label="item.subitemname+' '+item.subitem"
                            :value="item.subitem"
                        />
                    </el-select>
                    <el-input v-if="basicInfo.faxcycode !== '86'" v-model.trim="basicInfo.faxareacodeinput" placeholder="请输入地区码" :style="isTaTwo?'width:150px!important':''" />
                    <el-input v-model.trim="basicInfo.fax" placeholder="请输入传真" :maxlength="19" />
                </el-form-item>
                <el-form-item label="邮政编码：" prop="postcode">
                    <el-input v-model.trim="basicInfo.postcode" placeholder="请输入邮政编码" :maxlength="6" />
                </el-form-item>
                <el-form-item label="国籍/地区：" prop="country1">
                    <el-select
                        v-model="basicInfo.country"
                        filterable
                        placeholder="请选择国籍/地区"
                    >
                        <el-option
                            v-for="item in country"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="isTaTwo?basicInfo.country==='CN':basicInfo.country==='156'" label="省份：" prop="province">
                    <el-select
                        v-model="basicInfo.province"
                        filterable
                        placeholder="请选择省份"
                    >
                        <el-option
                            v-for="item in $cache.getDict('120122')||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="税收居民类型：" prop="taxestype">
                    <el-select
                        v-model="basicInfo.taxestype"
                        :disabled="true"
                        filterable
                        placeholder="请选择税收居民类型"
                    >
                        <el-option
                            v-for="item in $cache.getDict('120043')||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                    <div class="slot grey">
                        注：默认中国税收居民，如需修改请注册成功后前往税收居民信息处更新。
                    </div>
                </el-form-item>
                <el-form-item class="margin-top">
                    <el-button type="yellow" class="medium" v-on:click.prevent="submitForm('basicInfo')">
                        下一步
                    </el-button>
                    <el-button class="medium" type="back" v-on:click.prevent="$router.back()">
                        返回
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--内容-->
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import countryCitySelect from "@/components/acctInfo/countryCitySelect.vue";
import navBar from "@/components/common/navBar.vue";
import datePicker from "@/components/common/datePicker.vue";
import format from "date-fns/format";
export default {
    name: "ViewBasicInfo",
    components: {
        navBar,
        datePicker,
        countryCitySelect
    },
    mixins: [mixin],
    data () {
        return {
            navs: [
                {id: "1",val: "经办人信息"},
                {id: "2",val: "基本信息",active: "1"},
                {id: "3",val: "信息登记"},
                {id: "4",val: "银行信息"},
                {id: "5",val: "文件上传"},
                {id: "6",val: "完成注册",icon: "fa fa-check"}
            ],
            cardCate: [{
                id: "1",
                name: "一证一码",
                text: "若您的营业执照号为“一证一码”，请在以下输入框中输入统一社会信用代码号。"
            },{
                id: "2",
                name: "三证三码/一证三码",
                text: "若您的营业执照是“一证三码”或“ 三证三码”，请将同一证件在营业执照、组织机构代码证、税务登记证分别填写。"
            },{
                id: "3",
                name: "其它",
                text: ""
            }],
            mainvtp: [{ subitem: "0", subitemname: "机构" }],
            usefullifeObj: {
                country: "CN",
                province: null,
                city: null,
                county: null,
                address: null
            },
            livingAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null,
                address: null
            },
            isTaTwo: true,
            // dict
            custType: [],
            cardNum: [],
            orgCates: [],
            faxcycode: [],
            faxareacode: [],
            producttype: [],
            registercurrencytype: [],
            industrycode1: "",
            industrycode2: "",
            industrycode3: "",
            basicInfo: {
                productname: "",
                filingno: "",
                product: "",
                producttype: "",
                filinginstitution: "",
                begindate: "",
                enddate: "",
                finorgtype: "",
                certificatetype: "1",
                certificateno: "",
                certificateno1: "",
                certificateno2: "",
                certificateno3: "",
                usefullife: "",
                address: "",
                faxcycode: "86",
                faxareacode: "",
                faxareacodeinput: "",
                fax: "",
                postcode: "",
                country: "",
                province: "",
                custname: "",
                vailddate: "",
                custtype: "01",
                institutiontype: "",
                cardCate: "1",
                taxestype: "1",
                openAccoInfo: "",
                businessAttorneyInfo: "",
                agreementInfo: "",
                registeredcapital: "",
                registercurrencytype: "",
                scopeofbusiness: "",
                industrycode1: "",
                industrycode2: "",
                industrycode3: "",
                industrycode: "",
                lcountry: "",
                lprovince: "",
                lcity: "",
                lcounty: "",
                ucountry: "",
                uprovince: "",
                ucity: "",
                ucounty: "",
                mname: "",
                mainvtp: "0",
                mavailddate: "",
                macertificatetype: [],
                macertificateno: ""
            },
            dateSet: { type: "3", max: "", val: "",text: "请选择证件有效期" },
            beginSet: { type: "1", max: "", val: "",text: "请选择成立日期" },
            endSet: { type: "3", max: "", val: "",dis: true,text: "请选择证产品到期日期" },
            manaDateSet: { type: "3", max: "", val: "",text: "请选择管理人证件有效期" },
            country: [],
            rules: {
                product: [
                    { required: true, message: "请输入产品简称", trigger: "change" },
                    { validator: this.$util.validateCCharacter, trigger: "change" }
                ],
                productname: [
                    { required: true, message: "请输入产品名称", trigger: "change" },
                    { validator: this.$util.validateCCharacter, trigger: "change" }
                ],
                filingno: [
                    { validator: this.validateFilingno, trigger: "change" }
                ],
                mname: [
                    { required: true, message: "请输入产品管理人", trigger: "change" }
                    // { validator: this.$util.validateCCharacter, trigger: "change" }
                ],
                macertificatetype: [
                    { required: true, message: "请选择产品管理人证件类型", trigger: "change" }
                ],
                macertificateno: [
                    { required: true, message: "请输入产品管理人证件号码", trigger: "change" }
                ],
                filinginstitution: [
                    { required: true, message: "请输入产品备案机构", trigger: "change" },
                    { validator: this.$util.validateCCharacter, trigger: "change" }
                ],
                begindate: [
                    { required: true, message: "请选成立日期", trigger: "change" }
                ],
                enddate: [
                    { required: true, message: "请选产品到期日期", trigger: "change" }
                ],
                custname: [
                    { required: true, message: "请输入机构名称", trigger: "change" },
                    { validator: this.$util.validateName, trigger: "change" }
                ],
                finorgtype: [
                    { validator: this.validFinType, trigger: "change" }
                ],
                certificatetype: [
                    { required: true, message: "请选择其它证件类型", trigger: "change" }
                ],
                certificateno: [
                    { required: true, message: "请输入证件号码", trigger: "blur" },
                    { validator: this.checkCertNo, trigger: "blur" }
                ],
                certificateno1: [
                    { required: true, message: "请输入证件号码", trigger: "blur" },
                    { validator: this.checkCertNo, trigger: "blur" }
                ],
                certificateno2: [
                    { required: true, message: "请输入证件号码", trigger: "blur" },
                    { validator: this.checkCertNo, trigger: "blur" }
                ],
                certificateno3: [
                    { required: true, message: "请输入证件号码", trigger: "blur" },
                    { validator: this.checkCertNo, trigger: "blur" }
                ],
                vailddate: [
                    { required: true, message: "请选择证件有效期", trigger: "change" }
                ],
                mavailddate: [
                    { required: true, message: "请选择证件有效期", trigger: "change" }
                ],
                registeredcapital: [
                    { required: true, message: "请输入注册资本", trigger: "blur" }
                ],
                registercurrencytype: [
                    { required: true, message: "请选择注册资产币种", trigger: "change" }
                ],
                scopeofbusiness: [
                    { required: true, message: "请输入经营范围", trigger: "blur" }
                ],
                usefullife: [
                    { required: true, message: "请输入注册地址详细地址", trigger: "blur" },
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                address: [
                    { required: true, message: "请输入详细通讯地址", trigger: "blur" },
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                livingaddress: [
                    { validator: this.validateLivingaddress, trigger: "blur" }
                ],
                // fax: [
                //     { validator: this.$util.validateFaxNum, trigger: "blur" }
                // ],
                postcode: [
                    { required: true, message: "请输入邮政编码", trigger: "blur" },
                    { validator: this.$util.validatePostCode, trigger: "blur" }
                ],
                province: [
                    { required: true, message: "请选择省份", trigger: "change" }
                ]
            },
            invtp: "0"
        };
    },
    watch: {
        "basicInfo.cardCate"(val){
            if(val === "3"){
                this.basicInfo.certificatetype = this.invtp === "0" ? "0" : "8";
            }else{
                this.basicInfo.certificatetype = "1";
            }
        },
        "basicInfo.begindate"(val){
            this.$set(this.endSet,"min",format(val,"YYYY-MM-DD"));
            if(val !== "" && this.endSet.dis){
                this.$set(this.endSet,"dis",false);
            }
        },
        "basicInfo.enddate"(val){
            if(val){
                this.$set(this.beginSet,"max",format(val,"YYYY-MM-DD"));
            }
        },
        "basicInfo.faxcycode"(val){
            this.basicInfo.faxareacode = "";
            this.basicInfo.faxareacodeinput = "";
        },
        "basicInfo.faxareacodeinput"(val){
            this.basicInfo.faxareacode = this.basicInfo.faxareacodeinput;
        },
        "basicInfo.industrycode1"(val){
            let data = this.industrycode1.filter(function(item){
                return item.subitem == val;
            });
            this.basicInfo.industrycode2 = "";
            this.basicInfo.industrycode3 = "";
            this.industrycode2 = data[0].chirldren || [];
        },
        "basicInfo.industrycode2"(val){
            let data = this.industrycode2.filter(function(item){
                return item.subitem == val;
            });
            this.basicInfo.industrycode3 = "";
            this.industrycode3 = data[0].chirldren || [];
        },
        "basicInfo.registeredcapital"(val) {
            this.mustNum(val, "registeredcapital");
        },
    },
    mounted() {
        let _country = "";
        let _y = [];
        let _z = [];
        this.isTaTwo = sessionStorage.getItem("isTaTwo", "") || true;
        const type = this.$route.query ? this.$route.query.type : "";
        const conf = this.$util.getConfig().const;
        this.producttype = this.isTaTwo ? this.$cache.getDict("150127") : this.$cache.getDict("120113");
        this.faxcycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.faxareacode = this.$cache.getDict("150137");
        this.registercurrencytype = this.$cache.getDict("110050");
        this.macertificatetype = this.$cache.getDict("130008");
        this.dateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.endSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.beginSet.max = format(new Date(), "YYYY-MM-DD");
        this.manaDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.basicInfo.institutiontype = this.isTaTwo ? "107" : "0";
        this.basicInfo.country = this.isTaTwo ? "CN" : "156";
        this.initIndustryList();
        _country = this.isTaTwo ? this.$util.changeArrIndex(this.$cache.getDict("120109"), "CN") : this.$util.changeArrIndex(this.$cache.getDict("110049"), "156");
        for(let i in _country){
            if(_country[i].subitem === "156" || _country[i].subitem === "158" || _country[i].subitem === "344" || _country[i].subitem === "446"){
                _z.push(_country[i]);
                continue;
            }
            _y.push(_country[i]);
        }
        this.country = _z.concat(_y);
        if(this.$store.state.login.status && !this.$util.isEmpty(this.$cache.getUser().invtp)){
            return this.getHasInfo(type);
        }
        const _t = sessionStorage.getItem("_t") || "";
        if(_t){
            return this.getOpenInfo(type,_t);
        }
        this.initData(type);
    },
    methods: {
        setLivingAddr() {
            this.basicInfo["lcountry"] = this.livingAddressObj["country"];
            this.basicInfo["lprovince"] = this.livingAddressObj["province"];
            this.basicInfo["lcity"] = this.livingAddressObj["city"];
            this.basicInfo["lcounty"] = this.livingAddressObj["county"];
        },
        setUsefullAddr() {
            this.basicInfo["ucountry"] = this.usefullifeObj["country"];
            this.basicInfo["uprovince"] = this.usefullifeObj["province"];
            this.basicInfo["ucity"] = this.usefullifeObj["city"];
            this.basicInfo["ucounty"] = this.usefullifeObj["county"];
        },
        getUsefullife (data) {
            this.basicInfo.usefullife = data.address;
            if (data.country !== "CN") {
                this.livingAddressObj["province"] = "";
                this.livingAddressObj["city"] = "";
                this.livingAddressObj["county"] = "";
            }
        },
        getAddress(data){
            this.basicInfo.address = data.address;
            if (data.country !== "CN") {
                this.livingAddressObj["province"] = "";
                this.livingAddressObj["city"] = "";
                this.livingAddressObj["county"] = "";
            }
        },
        checkUsefullInfo(){
            let hasLivingAddrInfo = true;
            if(this.basicInfo.lcountry === "CN"){
                hasLivingAddrInfo = !!this.basicInfo.uprovince && !!this.basicInfo.usefullife && !!this.basicInfo.ucity;
            }else{
                hasLivingAddrInfo = !!this.basicInfo.usefullife;
            }
            if(!hasLivingAddrInfo){
                this.$alert("请完善注册地址(国家/地区-省-市-县)信息！","提示");
                return false;
            }
            return true;
        },
        checkLivingInfo(){
            let hasLivingAddrInfo = true;
            if(this.basicInfo.lcountry === "CN"){
                hasLivingAddrInfo = !!this.basicInfo.lprovince && !!this.basicInfo.address && !!this.basicInfo.lcity;
            }else{
                hasLivingAddrInfo = !!this.basicInfo.address;
            }
            if(!hasLivingAddrInfo){
                this.$alert("请完善通讯地址(国家/地区-省-市-县)信息！","提示");
                return false;
            }
            return true;
        },
        validateNum(rule, value, callback){
            const reg = /^[0-9]{4,20}$/;
            if (reg.test(value)) {
                callback();
            } else {
                callback(new Error("产品编号为4-20位数字"));
            }
        },
        // 行业字典初始化
        initIndustryList () {
            let dict = this.$cache.getDict("150145") || [];
            let a = /[a-z]/i;
            dict = dict.filter(item => {
                return !a.test(item.subitem);
            });
            dict = this.changeArr(dict);
            dict.reverse();
            for (let i = 0; i < dict.length; i++) {
                for (let j = 0; j < dict.length; j++) {
                    if (dict[i].subitem.indexOf(dict[j].subitem) == "0" && (dict[i].subitem.length - dict[j].subitem.length == "1")) {
                        if (!dict[j].chirldren) {
                            dict[j].chirldren = [];
                        }
                        dict[j].chirldren.push(dict[i]);
                        dict.splice(i,1);
                        i--;
                        break;
                    }
                }
            }
            this.industrycode1 = dict;
        },
        changeArr(dict) {
            for (let i = 0; i < dict.length - 1; i++) {
                for (let j = 0; j < dict.length - 1 - i; j++) {
                    if (dict[j].subitem > dict[j + 1].subitem) {
                        let temp = dict[j];
                        dict[j] = dict[j + 1];
                        dict[j + 1] = temp;
                    }
                }
            }
            return dict;
        },
        getHasInfo(type){
            const _this = this;
            this.$util.request("orgopen/refuse/info").then(res=>{
                if(res.data){
                    _this.initData(type,res.data[0]);
                }
            });
        },
        // 初始化缓存信息
        getOpenInfo(type,val){
            const _this = this;
            this.$util.request("orgopen/step",{transid: val}).then(res=>{
                if(res.data){
                    const data = res.data[0];
                    if(type === data.invtp){
                        const _type = type || res.data[0].invtp;
                        _this.initData(_type,data);
                    }else{
                        _this.initData(type);
                    }
                }
            });
        },
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            this.$util.validateCertNo(rule, value, callback, this.basicInfo.certificatetype);
        },
        validateFilingno(rule, value, callback){
            if(value !== ""){
                this.$util.validateCharNo(rule, value, callback);
            }else {
                if(this.basicInfo.producttype === "201" || this.basicInfo.producttype === "202" || this.basicInfo.producttype === "205" || this.basicInfo.producttype === "206" ||
                    this.basicInfo.producttype === "213" || this.basicInfo.producttype === "9" || this.basicInfo.producttype === "A" || this.basicInfo.producttype === "D" ||
                    this.basicInfo.producttype === "E" || this.basicInfo.producttype === "L"){
                    if(value === ""){
                        callback(new Error("请输入产品编号"));
                    }else{
                        this.$util.validateCharNo(rule, value, callback);
                    }
                }else {
                    callback();
                }
            }
        },
        validFinType(rule, value, callback){
            if(this.basicInfo.custtype !== "02"){
                callback();
            }else{
                if(value === ""){
                    callback(new Error("请选择金融机构类型"));
                }else{
                    callback();
                }
            }
        },
        validateLivingaddress(rule, value, callback){
            if(!value){
                callback(new Error("请输入详细地址"));
            }else{
                callback();
            }
        },
        // 检查文件是否上传
        checkFile(rule, value, callback){
            if(!this.file[rule.field] || !this.file[[rule.field]].name){
                callback(new Error("请上传文件"));
            }else{
                callback();
            }
        },
        initData(val,info){
            this.invtp = val || this.invtp;
            info = info || {};
            // 机构开户
            const custType = this.$cache.getDict("120048");
            if(this.invtp === "0"){
                const _card = this.$cache.getDict("130008") || [];
                this.cardNum = _card.filter(item=>{
                    return item.subitem !== "1";
                });
                this.custType = custType.filter(item=>{
                    return item.subitem !== "11" && item.subitem !== "12";
                }) || [];
                this.orgCates = this.isTaTwo ? this.$cache.getDict("150126") : this.$cache.getDict("120112");
                this.basicInfo.custtype = info.invtp === "0" ? info.custtype : "01";
                this.basicInfo.institutiontype = info.invtp === "0" ? info.institutiontype : (this.isTaTwo ? "107" : "0");
            }else if(this.invtp === "2"){
                // 产品开户
                this.custType = custType;
                const _card = this.$cache.getDict("120095") || [];
                this.cardNum = _card.filter(item=>{
                    return item.subitem !== "1";
                });
                this.orgCates = this.isTaTwo ? this.$cache.getDict("150127") : this.$cache.getDict("120113");
                this.basicInfo.custtype = info.invtp === "0" ? info.custtype : "12";
                this.basicInfo.institutiontype = info.invtp === "0" ? info.custtype : (this.isTaTwo ? "219" : "6");
                this.basicInfo.producttype = info.invtp === "0" ? info.producttype : (this.isTaTwo ? "219" : "6");
            }
            if(info.invtp){
                const _x = {
                    custname: info.custfullname,
                    finorgtype: info.finorgtype.trim(),
                    vailddate: info.vailddate,
                    usefullife: info.usefullife,
                    registercurrencytype: info.registercurrencytype,
                    registeredcapital: info.registeredcapital,
                    scopeofbusiness: info.scopeofbusiness,
                    address: info.address,
                    fax: info.fax.trim(),
                    faxcycode: info.faxcycode,
                    faxareacode: info.faxareacode,
                    postcode: info.postcode.trim(),
                    country: info.country,
                    province: info.province,
                    taxestype: info.taxestype,
                    usefullifecountry: info.usefullifecountry,
                    usefullifeprovince: info.usefullifeprovince,
                    usefullifecity: info.usefullifecity,
                    usefullifecounty: info.usefullifecounty,
                    livingcountry: info.livingcountry,
                    livingaddressprovince: info.livingaddressprovince,
                    livingaddresscity: info.livingaddresscity,
                    livingaddresscounty: info.livingaddresscounty
                };
                _x.begindate = info.foundingdate;
                this.$set(this.beginSet,"val",this.$util.fmtDate(info.foundingdate));
                // 产品客户初始化
                if(info.invtp === "2"){
                    _x.productname = info.productname;
                    _x.producttype = info.institutiontype;
                    _x.product = info.custname;
                    _x.filingno = info.filingno;
                    _x.filinginstitution = info.filinginstitution;
                    _x.enddate = info.productenddate;
                    this.$set(this.endSet,"val",this.$util.fmtDate(info.productenddate));
                }
                this.$set(this.dateSet,"val",this.$util.fmtDate(info.vailddate));
                if(info.certificatetype === "1"){
                    if(this.$util.isEmpty(info.taxregistrationcert)){
                        _x.cardCate = "1";
                    }else{
                        _x.cardCate = "2";
                        _x.certificateno1 = info.taxregistrationcert;
                        _x.certificateno2 = info.organization;
                    }
                    _x.certificateno3 = info.certificateno;
                }else{
                    _x.cardCate = "3";
                    _x.certificatetype = info.certificatetype;
                    _x.certificateno = info.certificateno;
                }
                this.basicInfo = Object.assign({},this.basicInfo,_x);
            }
        },
        dateInterval (val) {
            this.basicInfo.vailddate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.basicInfo.validateField("vailddate");
        },
        mavailddate (val) {
            this.basicInfo.mavailddate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.basicInfo.validateField("mavailddate");
        },
        beginDate (val) {
            this.basicInfo.begindate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.basicInfo.validateField("begindate");
        },
        endDate (val) {
            this.basicInfo.enddate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.basicInfo.validateField("enddate");
        },
        submitForm(name){
            const _this = this;
            this.setLivingAddr();
            this.setUsefullAddr();
            if(!this.checkUsefullInfo() || !this.checkLivingInfo()){
                return;
            }
            if(this.isTaTwo && this.basicInfo.fax !== "" && this.basicInfo.faxareacode === ""){
                this.$alert("请选择地区码！");
                return;
            }
            let industrycode = this.basicInfo.industrycode3 || this.basicInfo.industrycode2 || this.basicInfo.industrycode1;
            if (industrycode.length !== 4) {
                this.$alert("请选择具体行业！");
                return;
            }
            this.$refs[name].validate((valid) => {
                if (valid) {
                    let data = {};
                    if (_this.basicInfo.country === "156") {
                        data.belongregion = "中国";
                        data.location = _this.basicInfo.province;
                    } else {
                        data.belongregion = "外国";
                        data.location = _this.basicInfo.country;
                    }
                    _this.$util.request("orgopen/search/highrisk",data).then(res=>{
                        if(res.data){
                            if(res.data[0].highriskfalg === "1"){
                                _this.$alert("尊敬的客户您好，您所在的国籍或省份为反洗钱法规确认的高危地区，请您进行修改！", "高风险地区提示", {
                                    confirmButtonText: "确认",
                                    type: "warning"
                                });
                                return;
                            }else{
                                _this.updateInfo();
                            }
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        updateInfo(){
            const _this = this;
            const _x = Object.assign({},this.basicInfo);
            const _data = {
                custtype: _x.custtype,
                institutiontype: this.invtp === "2" ? _x.producttype : _x.institutiontype,
                custfullname: this.invtp === "0" ? _x.custname : _x.productname,
                certificatetype: _x.certificatetype,
                certificateno: _x.cardCate === "3" ? _x.certificateno : _x.certificateno3,
                vailddate: _x.vailddate,
                registercurrencytype: _x.registercurrencytype,
                registeredcapital: _x.registeredcapital,
                scopeofbusiness: _x.scopeofbusiness,
                industrycode: _x.industrycode3 || _x.industrycode2 || _x.industrycode1,
                usefullife: _x.usefullife,
                transid: this.$store.state.login.transid,
                address: _x.address,
                livingaddress: _x.address,
                usefullifecountry: _x.ucountry,
                usefullifeprovince: _x.uprovince,
                usefullifecity: _x.ucity,
                usefullifecounty: _x.ucounty,
                livingcountry: _x.lcountry,
                livingaddressprovince: _x.lprovince,
                livingaddresscity: _x.lcity,
                livingaddresscounty: _x.lcounty,
                fax: _x.fax,
                faxcycode: _x.faxcycode,
                faxareacode: _x.faxareacode,
                postcode: _x.postcode,
                country: _x.country,
                province: _x.province,
                otherprovince: _x.province,
                taxestype: _x.taxestype,
                invtp: this.invtp,
                organization: _x.cardCate === "2" ? _x.certificateno2 : (_x.cardCate === "1" ? _x.certificateno3 : ""),
                taxregistrationcert: _x.cardCate === "2" ? _x.certificateno1 : (_x.cardCate === "1" ? _x.certificateno3 : ""),
                finorgtype: _x.custtype === "02" ? _x.finorgtype : "",
                foundingdate: _x.begindate,
                // 产品客户
                productname: this.invtp === "2" ? _x.productname : "",
                // producttype: this.invtp === "2" ? _x.producttype : "",
                custname: this.invtp === "2" ? _x.product : _x.custname,
                filingno: this.invtp === "2" ? _x.filingno : "",
                filinginstitution: this.invtp === "2" ? _x.filinginstitution : "",
                productenddate: this.invtp === "2" ? _x.enddate : "",
                professionflag: this.invtp === "2" ? "1" : "0",
                productmanager: this.invtp === "2" ? _x.mname : "",
                mname: this.invtp === "2" ? _x.mname : "",
                mainvtp: this.invtp === "2" ? _x.mainvtp : "",
                macertificatetype: this.invtp === "2" ? _x.macertificatetype : "",
                macertificateno: this.invtp === "2" ? _x.macertificateno : "",
                mavailddate: this.invtp === "2" ? _x.mavailddate : ""
            };
            const _d = {
                certificatetype: _data.certificatetype,
                organization: _data.organization,
                invtp: this.invtp,
                taxregistrationcert: _data.taxregistrationcert
            };
            sessionStorage.setItem("refuse",JSON.stringify(_d));
            this.$util.request("orgopen/save/baseinfo",_data,"POST").then(res=>{
                if(res.data){
                    _this.$router.push({name: "orgregister"});
                }
            });
        },
        mustNum (val, param) {
            const _x = this.$util.filterNum(val);
            this.$set(this.basicInfo, param, _x);
        }
    }
};
</script>
<style lang="scss">
    .view-basic-info {
        margin-top: 5px;
        padding: 10px 55px;
        .basic-form{
            .el-select{width: 50%;
            }
        }
        /*颜色，背景写在css/theme.scss内views style下*/
        .pTip {
            text-align: center;
            font-size: 17px;
            border-bottom: 1px solid rgba(0,0,0,0.1);
            margin-bottom: 10px;
        }
    }
</style>
